import { render, staticRenderFns } from "./UserLists.vue?vue&type=template&id=0cd491bd&"
import script from "./UserLists.vue?vue&type=script&lang=js&"
export * from "./UserLists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports